/* eslint-disable no-nested-ternary */
/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, { useState, useEffect, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import styles from "./styles.css";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";
import { carDetailUrlAu } from "../../../utils/helpers/get-detail-page-url";
import withWishlist from "../with-wishlist";
import CloseButton from "../../shared/icon-cross";

import { getTooltipInfoList, getPersonalisedTooltipInfoList } from "../../../utils/helpers/car-properties";
import withLogin from "../with-login";
import TrackableCarCardItem from "../trackable-car-card-item";
import carListingEventDataParser, { parseFilterToDimension } from "../../../tracking/parser/car-listing";
import carListingEventDataParserGA4, { parseFilterToDimensionGA4 } from "../../../tracking/parser/car-listing-ga4";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";

import { cmsURl } from "../../../constants/url-constants";
import { smallImage } from "../../../constants/image-constant";
import LazyImage from "../../shared/lazy-image";
import { getCheckoutPageURL } from "../../../utils/helpers/get-detail-page-url";
import { CHECKOUT_ROUTE_PATHS } from "../../../constants/au.desktop/checkout-route-paths";

import loadable from "@loadable/component";
import {  INVENTORY_CAR_CARD_LABELS, NUMBER, PAGE_SOURCE, SPECIALPAGETYPE, CLASSIFIED_BRANDING_CONSTANTS, FILTER_KEYS, LEAD_APPOINTMENT_STATUS, API_SOURCE, getSellerTypeStyle, PLATFORMS, STYLE_COMPONENTS, STYLE_KEYS } from "../../../constants/app-constants";

const EGCPriceView = loadable(() => import("../egc-price-view"), {ssr: false});
import KbbPriceScreen from "../../shared/kbb-price-screen/component";
import { FB_EVENTS_CATEGORY } from "../../../tracking/fb-events";
import getQueryParamsSearch from "../../../utils/helpers/get-query-params-search";
import getCarInfo from "../../../utils/helpers/get-car-info";
import { imageTypes } from "../../../utils/helpers/cdn-image-url";
import { GUEST_POPUP_TYPES, LOGIN_SOURCE } from "../../../au-c2b/constants/app-constants";
import { LOGIN_TYPE } from "../../../constants/checkout-constants";
import { GA_EVENTS } from "./tracking";
import { GA_EVENTS as CLASSIFIED_GA_EVENTS } from "../login/tracking";
import getCurrentPage from "../../../utils/helpers/get-current-page";
// import CarouselPills from "./carousel-pills";

import ClpInventoryCarCardBadges from "../clp-inventory-car-card-badges/component";
import { getAbExpirementVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
import useCarHighlightLocation from "../../../hooks/use-car-highlight-location";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import Slider from "react-slick";
import CustomReactSlickNavigation from "../../shared/custom-react-slick-navigation/component";

import HeartIcon from "../../shared/heart-icon";
import { SECTION_SOURCE } from "./constant";
import VideoGallerySliderModal from "../video-gallery-slider-modal";
import { VIDEO_CATALOG_AMPLITUDE_EVENTS, VIDEO_CATALOG_GA_EVENTS_DESKTOP } from "../video-gallery-slider/tracking";

import Tooltip from "../../shared/tooltip";
import InfoIcon from "./images/info-icon-white.svg";
import InfoOutline from "./images/info-outline.svg";
import ArrowIcon from "./images/arrow.webp";
import locationImg from "./images/location.svg";
import stickyNote from "./images/sticky-note.svg";
import CarouselPills from "./carousel-pills";
import { getDealerPage } from "../../../utils/helpers/get-dealer-route";
import DealerLocationModal from "../../shared/dealer-location-modal/component";
import SellerTypeInfo from "../seller-type-info/component";
// import useInterstateLocation from "../../../hooks/use-interstate-location";
import getClassifiedConfigEnabled from "../../../utils/helpers/get-classified-config";
import LoggedInDealerRedirectModal from "../logged-in-dealer-redirect-modal";
import { VIDEO_TOUR_ICON } from "../../../constants/image-url-constant";
import { useSortingExperiment } from "../../../hooks/use-sorting-experiment";
import { getScrollKey, saveScrollPosition } from "../../../utils/helpers/scroll-position";

const InventoryCarCard = ({
    booked = false,
    year,
    appointmentId: carId,
    make,
    model,
    bodyType = "",
    price,
    egc,
    variant,
    fuelType,
    config = {},
    onClickCallback = () => { },
    transmissionType,
    history,
    emiDetails,
    isLoggedIn,
    openLoginPopupConnect,
    setOnLoginSuccessCallback,
    secureToken,
    isWishlistedCar = () => { },
    onClickAddToWishList,
    gtmFrom,
    showWishlist = true,
    showRemoveIcon = false,
    defaultTootlipStyle,
    allFilters,
    appliedFilters,
    item,
    index,
    selectedSort,
    impressionSource,
    comingSoon = false,
    egcRenderType,
    listingActive,
    saveCheckoutSourcePathnameConnect,
    personalised,
    cardType = "COMMON",
    selectedCity = {},
    handleEcgViewCallback = () => { },
    tradeInToggleSelected,
    userTradeInData,
    kbbAskingPrice,
    vehicleRetailPrice,
    email,
    listingType,
    isUserZeroDpVariant,
    ampPageSource,
    carCardActionTarget = "_self",
    setLoginTypeConnect,
    preload = false,
    showPriceWithTradeInApplied,
    preventDefaultEvents,
    isGuestLogin,
    guestLoginProps,
    showLocationCallback,
    webPriceDropDesktop,
    vehicleShortlistData,
    fomoText = {},
    desktopWishlistAdoption,
    showFomoStrip,
    sectionSource,
    webCarTour,
    fetchCarDetailsConnect,
    setVideoGalleryModalOpenConnect,
    desktopCtaOptimization,
    distance,
    createClassifiedLeadConnect,
    phoneNumberVerified,
    cmsConfig,
    getDealerInfoConnect,
    fetchLeadAppointmentConnect,
    dealerInfo,
    classifiedConfig,
    leadAppointment,
    globalCmsConfig,
    locationLabel,
    stagingDealerBadge,
    desktopLuxuryCars,
    isSourceSimilarCars = false
}) => {
    const [showEcgPrice, setShowEcgPrice] = useState(false);
    // const [toolTipTitle, setToolTipTitle] = useState("");
    const [toolTipBody, setToolTipBody] = useState([]);
    const [showKBBModal, setShowKBBModal] = useState(false);
    const [dealerLocationModal, setShowDealerLocationModal] = useState(false);
    const [showVideoGalleryModal, setShowVideoGalleryModal] = useState(false);
    const [showLoggedInDealerRedirectModal, setShowLoggedInDealerRedirectModal] = useState(false);
    const [dealerRedirectRoute, setDealerRedirectRoute] = useState("");
    const [carContent, setCarContent] = useState(null);
    const [cardImageData, setCardImageData] = useState({ currentIndex: null, timerId: null, stopAnimation: false, startTimestamp: null });
    const searchQuery =  getQueryParamsSearch();
    const { carFullName, carImage: imageUrl, kilometerLabel, priceLabel, carAltTag, imagesArray = [], carLabel, initialListingPrice, cityCode, defaultSale, isInternalListing, sold, isLuxuryCar, hasTransparentCarImage} = getCarInfo(item, { ...config, displayImageType: imageTypes.gsCarCardDesktop });
    const [selectedWishlistCarId, setSelectedWishlistCarId] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isHydrated, setIsHydrated] = useState(false);
    useEffect(() => { setIsHydrated(true); }, []);
    const sliderRef = useRef(null);
    const [beforeChangeIndex, setBeforeChangeIndex] = useState({before: 0, next: 0});
    const clickSliderGallery = [...imagesArray, imagesArray[0]];
    const cardHoverRef = useRef(null);
    const [showWishlistNote, setShowWishlistNote] = useState(false);
    const showWebCarTour = getAbExpirementVariant(webCarTour, EXPERIMENT_TYPE.VARIANT_B);
    const isDesktopCtaOptimizationVariant = getAbExpirementVariant(desktopCtaOptimization, EXPERIMENT_TYPE.VARIANT_B);
    const isDesktopLuxuryCarsVariant = getAbExpirementVariant(desktopLuxuryCars, EXPERIMENT_TYPE.VARIANT_B);

    const carName = `${make || ""} ${model || ""}`;
    const comingSoonImage = smallImage[bodyType.toLowerCase()] || smallImage.sedan;
    const comingSoonImageSrc = imageUrl || comingSoonImage;
    const { relativeURL, absoluteURL } = carDetailUrlAu({ year, carName, carId });
    const { tradeIn = false } =  userTradeInData || {};
    const { estimatedPrice = 0, kbbValueProvidedOn } = item || {};
    const { isListingPage: isListingPageDesktop} = getCurrentPage();
    const isListingPage = isListingPageDesktop && sectionSource !== SECTION_SOURCE.CAROUSEL;

    const {currentCarCityInfo = {}} = useCarHighlightLocation(cityCode);
    const {cityName: currentCarLocation} = currentCarCityInfo || {};
    // const {isInterstateLocation = false} = useInterstateLocation({content: item}) || {};
    const vehicleAskingPrice = vehicleRetailPrice || kbbAskingPrice || 0;
    const kbbMarketPrice = vehicleAskingPrice - egc;
    const showKbbMarketPrice = egc < vehicleAskingPrice && kbbMarketPrice >=  NUMBER.FIVE_HUNDRED &&
    kbbMarketPrice < NUMBER.TEN_THOUSAND ? kbbMarketPrice : false;
    const {
        emiPerWeek = 0,
        defaultDownPayment
    } = emiDetails || {};
    const showWebPriceDesktop = getAbExpirementVariant(webPriceDropDesktop, EXPERIMENT_TYPE.VARIANT_B);
    const isPriceDropCar = showWebPriceDesktop && carLabel === INVENTORY_CAR_CARD_LABELS.PRICE_DROP && ((currentIndex === 0));
    const {note: wishlistNote} = vehicleShortlistData || {};
    const {text: carCardFomoText = "", key: carCardFomoKey = "", fomoIcon} = fomoText || {};
    const isDesktopWishlistAdoptionVariant = getAbExpirementVariant(desktopWishlistAdoption, EXPERIMENT_TYPE.VARIANT_B);
    const [showSellerTypeInfo, setShowSellerTypeInfo] = useState({
        view: false,
        key: FILTER_KEYS.CARS24
    });
    const {
        dealerCode
    } = item || {};

    const dealerInfoObject = dealerInfo?.[dealerCode] || {};
    const {sortingVariant} = useSortingExperiment({source: API_SOURCE.WEB_APP});
    const isClassifiedEnabled = getClassifiedConfigEnabled(classifiedConfig, sortingVariant);

    useEffect(() => {
        if (personalised) {
            // setToolTipTitle(`Weekly payment of ${makePriceLabelRound(emiPerWeek)}`);
            setToolTipBody(getPersonalisedTooltipInfoList(emiDetails));
        } else {
            // setToolTipTitle(`Weekly payment of ${makePriceLabelRound(emiPerWeek)}`);
            setToolTipBody(getTooltipInfoList(emiDetails, isUserZeroDpVariant));
        }
    }, [emiPerWeek, emiDetails, personalised, isUserZeroDpVariant]);

    const filterDimensions = parseFilterToDimension(allFilters, appliedFilters, selectedSort);
    const filterDimensionsGA4 = parseFilterToDimensionGA4(allFilters, appliedFilters, selectedSort);

    const ecommerEventData = () => {
        const data = carListingEventDataParser(item, {
            position: index + 1,
            list: impressionSource,
            filterDimensions
        });
        return data;
    };

    const eventData = () => {
        const data = ecommerEventData();
        return {
            name: AU_DESKTOP_EVENTS.CAR_IMPRESSION,
            data: {
                ...data.carsImpression
            }
        };
    };

    const eventDataGA4 = () => {
        const dataGA4 = carListingEventDataParserGA4(item, {
            position: index + 1,
            listingType,
            filterDimensions: filterDimensionsGA4,
            isWishlisted: isWishlistedCar(carId)
        });
        return {
            name: AU_DESKTOP_EVENTS.VIEW_ITEM_LIST,
            data: {
                user_id: email,
                ...dataGA4
            }
        };
    };

    const trackCardClickEvent = () => {
        if (preventDefaultEvents) return;
        const data = carListingEventDataParser(item, { position: index + 1, list: impressionSource, filterDimensions});
        const dataGA4 = carListingEventDataParserGA4(item, { filterDimensions: filterDimensionsGA4, listingType, position: index + 1});
        trackDesktopCustomEventsAU("clearEcommerce", { ecommerce: null });
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.SELECT_ITEM, { user_id: email, ...dataGA4});
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_CLICK, data.carClick);
        if (cardType === SPECIALPAGETYPE.LOCATION_BASED) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LISTING_PAGE, {
                eventAction: `car_listing_card_open_${(selectedCity || {}).name}`,
                eventLabel: "{{view_details}}"
            });
        }
        if (searchQuery) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LISTING_PAGE, {
                eventAction: "search_result_click",
                eventLabel: `Click Position: ${index + 1} Appointment ID: ${carId}`
            });
        }
    };

    const onCardClickHandler = async(e) => {
        e.preventDefault();
        // Save current CLP scroll position before navigating to CDP
        try {
            const key = getScrollKey(window.location.pathname, window.location.search);
            saveScrollPosition(key, window.pageYOffset);
        } catch (_e) { /* ignore */ }
        onClickCallback(item);
        history.push(relativeURL);
        await yieldToMain();
        trackCardClickEvent();
        try {
            history.push(relativeURL);
        } catch (_e) { /* ignore navigation errors */ }
    };

    const preventPropagation = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
    const handleSliderDirection = (direction) => {

        if (direction === "prev") {
            sliderRef.current.slickPrev();
        } else {
            sliderRef.current.slickNext();
        }
    };
    const handleAfterChange = (value) => {
        setCurrentIndex(value);
        yieldToMain();
        trackDesktopCustomEventsAU(GA_EVENTS.DESKTOP_CARD_GALLERY_SCROLLED, {
            ...GA_EVENTS.DESKTOP_CARD_GALLERY_SCROLLED,
            eventLabel: value + 1
        });
    };

    const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        swipe: false,
        touchMove: false
    };

    const onClickWishlistGAEvent = () => {
        if (isWishlistedCar(carId)) {
            trackDesktopCustomEventsAU(GA_EVENTS.WISHLIST_REMOVED, {
                ...GA_EVENTS.WISHLIST_REMOVED,
                eventLabel: carId,
                eventAction: ampPageSource
            });
        } else {
            trackDesktopCustomEventsAU(GA_EVENTS.WISHLIST_DONE, {
                ...GA_EVENTS.WISHLIST_DONE,
                eventLabel: carId,
                eventAction: ampPageSource
            });
        }
        if (isWishlistedCar(carId)) {
            trackDesktopCustomEventsAU(GA_EVENTS.WISHLIST_CARS_FOMO_IMPRESSION, {
                ...GA_EVENTS.WISHLIST_CARS_FOMO_IMPRESSION,
                eventLabel: carId,
                eventAction: ampPageSource
            });
        }

        if (cardType === SPECIALPAGETYPE.LOCATION_BASED) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CARS24_AU_ALL_PAGES, {
                eventAction: `wishlist_cta_selected_${(selectedCity || {}).name}`,
                eventLabel: "listing_page"
            });
        }
    };

    const onWishlistLoginSuccess = (resp, id) => {
        const { access_token: token } = resp.profileResponse || resp;
        const {addtoWishList} = ecommerEventData();
        onClickWishlistGAEvent();
        onClickAddToWishList(id, token, gtmFrom, { comingSoon, make, model,  callback: () => {setSelectedWishlistCarId(null);}, errorCallback: () => {setSelectedWishlistCarId(null);} });
        trackDesktopCustomEventsAU(FB_EVENTS_CATEGORY.ADD_TO_WISHLIST, {content: addtoWishList});
    };

    const onClickWishlist = (e) => {
        setSelectedWishlistCarId(carId);
        const {addtoWishList} = ecommerEventData();
        if (e) { preventPropagation(e); }
        if (isLoggedIn) {
            onClickWishlistGAEvent();
            onClickAddToWishList(carId, secureToken, gtmFrom, { comingSoon, make, model,  callback: () => {setSelectedWishlistCarId(null);}, errorCallback: () => {setSelectedWishlistCarId(null);} });
            trackDesktopCustomEventsAU(FB_EVENTS_CATEGORY.ADD_TO_WISHLIST, {content: addtoWishList});
        } else {
            openLoginPopupConnect();
            setLoginTypeConnect(LOGIN_TYPE.WISHLIST);
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LOGIN_INITIATED, {eventLabel: LOGIN_SOURCE.WISHLIST});
            setOnLoginSuccessCallback((resp) => onWishlistLoginSuccess(resp, carId));
        }
    };

    const comingSoonInfo = (e) => {
        preventPropagation(e);
        window.open(`${cmsURl()}/pages/coming-soon`, "_blank");
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.COMING_SOON_LISTING_INFO);
    };

    const getStarted = () => {
        saveCheckoutSourcePathnameConnect(history.location.pathname);
        const { relativeURL: checkoutPageUrl } = getCheckoutPageURL({ make, model, appointmentId: carId }, CHECKOUT_ROUTE_PATHS.deliveryDetails);
        if (isLoggedIn) {
            history.push(checkoutPageUrl);
        } else {
            openLoginPopupConnect();
            setOnLoginSuccessCallback(() => history.push(checkoutPageUrl));
        }
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.STATE_WISE_PRICE_BREAKDOWN_GET_STARTED, {
            eventCategory: "Cars24_listing_page"
        });
    };

    const handleEcgView = () => {
        setShowEcgPrice(!showEcgPrice);
        handleEcgViewCallback(!showEcgPrice);
        if (!showEcgPrice) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.STATE_WISE_PRICING_INFO_ICON);
        }
    };
    const getCta = () => {
        const cta = { text: "GET STARTED", action: getStarted, disabled: false };
        cta.disabled = (comingSoon || booked || !listingActive);
        return cta;
    };

    const handleOpenMarketModal = async (e) => {
        preventPropagation(e);
        setShowKBBModal(!showKBBModal);
        await yieldToMain();
        if (!showKBBModal) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LISTING_BELOW_MARKET_CLICKED, {eventLabel: `${showKbbMarketPrice}_${carId}`});
        }
    };

    const handleRepaymentInfoClick = useCallback(
        async (isOpen) => {
            await yieldToMain();
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.INFO_ICON_REPAYMENT, {
                eventLabel: `Repayment_icon_${gtmFrom}`,
                eventAction: isOpen ? "Repayment_icon_opened" : "Repayment_icon_closed"
            });
        },
        [gtmFrom]
    );

    // eslint-disable-next-line consistent-return
    const cardClickWrapper = (e) => {
        e.preventDefault();
        if (ampPageSource !== PAGE_SOURCE.SELL_VALUATION_PAGE || isLoggedIn) {
            return onCardClickHandler(e);
        }
        if (isGuestLogin) {
            const { setOnGuestEmailVerifyCallback, openGuestLoginConnect} = guestLoginProps;
            openGuestLoginConnect(GUEST_POPUP_TYPES.VERIFY);
            setOnGuestEmailVerifyCallback(() => onCardClickHandler(e));
        } else {
            openLoginPopupConnect();
            setOnLoginSuccessCallback(() => onCardClickHandler(e));
        }
    };
    const updateState = (newState) => {
        setCardImageData((prevState) => ({ ...prevState, ...newState }));
    };
    useEffect(() => {
        if (cardImageData.stopAnimation) {
            window.clearInterval(cardImageData.timerId);
            updateState({ currentIndex: 0, stopAnimation: false });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cardImageData.stopAnimation]);
    const getLabelText = () => {
        switch (carLabel) {
        case INVENTORY_CAR_CARD_LABELS.DISCOUNT:
            return `${makePriceLabelRound(price - egc)} off`;
        case INVENTORY_CAR_CARD_LABELS.NEW:
            return "New stock";
        case INVENTORY_CAR_CARD_LABELS.DEALER:
            return "Verified dealer";
        case INVENTORY_CAR_CARD_LABELS.PRICE_DROP:
            return "Price drop";
        case INVENTORY_CAR_CARD_LABELS.COMING_SOON:
            return "Coming soon";
        default:
            return carLabel;
        }
    };

    const handleLocationClick = async (e) => {
        preventPropagation(e);
        if (isInternalListing) {
            showLocationCallback();
        } else {
            // Fetch fresh dealer info and lead appointment data
            if (dealerCode) {
                getDealerInfoConnect({ dealerId: dealerCode });
            }
            fetchLeadAppointmentConnect(carId);
            setShowDealerLocationModal(true);
            return;
        }
        await yieldToMain();
        trackDesktopCustomEventsAU(GA_EVENTS.LOCATION_LINK_CLICKED.eventAction, {
            ...GA_EVENTS.LOCATION_LINK_CLICKED,
            eventLabel: currentCarLocation
        });
    };

    const onLoginClick = () => {
        const dealerName = dealerInfo?.[dealerCode]?.name || "";
        const dealerPage = getDealerPage(dealerName, dealerCode);
        if (phoneNumberVerified && leadAppointment?.status === LEAD_APPOINTMENT_STATUS.CONFIRM) {
            trackDesktopCustomEventsAU(CLASSIFIED_GA_EVENTS.CLASSIFIED_LEAD_INITIATED, {
                ...CLASSIFIED_GA_EVENTS.CLASSIFIED_LEAD_INITIATED,
                eventLabel: "LOCATION"
            });
            createClassifiedLeadConnect(carId).then((leadResponse) => {
                trackDesktopCustomEventsAU(CLASSIFIED_GA_EVENTS.CLASSIFIED_LEAD_COMPLETED, {
                    ...CLASSIFIED_GA_EVENTS.CLASSIFIED_LEAD_COMPLETED,
                    eventLabel: leadResponse?.leadCode || null
                });
            });
            history.push(dealerPage);
        } else if (phoneNumberVerified && leadAppointment?.status !== LEAD_APPOINTMENT_STATUS.CONFIRM) {
            trackDesktopCustomEventsAU(CLASSIFIED_GA_EVENTS.CLASSIFIED_LEAD_INITIATED, {
                ...CLASSIFIED_GA_EVENTS.CLASSIFIED_LEAD_INITIATED,
                eventLabel: "LOCATION"
            });
            createClassifiedLeadConnect(carId).then((leadResponse) => {
                trackDesktopCustomEventsAU(CLASSIFIED_GA_EVENTS.CLASSIFIED_LEAD_COMPLETED, {
                    ...CLASSIFIED_GA_EVENTS.CLASSIFIED_LEAD_COMPLETED,
                    eventLabel: leadResponse?.leadCode || null
                });
            });
            setDealerRedirectRoute(dealerPage);
            setShowLoggedInDealerRedirectModal(true);
        } else {
            setOnLoginSuccessCallback(() => {
                history.push(dealerPage);
            });
            openLoginPopupConnect({
                additionalInfo: { loginSource: LOGIN_SOURCE.CLASSISFIEDS, appointmentId: carId, carDetails: item, source: "LOCATION" }
            });
        }
    };

    const handleViewDealerFromModal = () => {
        setShowLoggedInDealerRedirectModal(false);
        if (dealerRedirectRoute) {
            history.push(dealerRedirectRoute);
        }
    };

    const onHandleViewMoreImageClickHandler = async(e) => {
        e.preventDefault();
        history.push(relativeURL);
        await yieldToMain();
        trackDesktopCustomEventsAU(GA_EVENTS.DESKTOP_CARD_GALLERY_CLICKED, {
            ...GA_EVENTS.DESKTOP_CARD_GALLERY_CLICKED,
            eventLabel: carId
        });
        trackCardClickEvent();
    };

    // eslint-disable-next-line consistent-return
    const handleViewMoreImages = async(e) => {
        preventPropagation(e);
        if (isSourceSimilarCars) {
            onClickCallback(item);
        }
        if (ampPageSource !== PAGE_SOURCE.SELL_VALUATION_PAGE || isLoggedIn) {
            return onHandleViewMoreImageClickHandler(e);
        }
        if (isGuestLogin) {
            const { setOnGuestEmailVerifyCallback, openGuestLoginConnect} = guestLoginProps;
            openGuestLoginConnect(GUEST_POPUP_TYPES.VERIFY);
            setOnGuestEmailVerifyCallback(() => onHandleViewMoreImageClickHandler(e));
        } else {
            openLoginPopupConnect();
            setOnLoginSuccessCallback(() => onHandleViewMoreImageClickHandler(e));
        }
    };
    // const handleShowCarousel = (value) => {
    //     setShowCarousel(value);
    // };

    const handleBeforeChange = (current, next) => {
        setBeforeChangeIndex({...beforeChangeIndex, current, next});
    };

    const renderListingCardImage = (url, imgIndex) => {

        return (
            <div>
                {imgIndex === NUMBER.ZERO && index < NUMBER.THREE ?
                    <img
                        styleName={`styles.revampMainImage styles.carCardImage`}
                        alt={carAltTag}
                        src={url}
                        key={imgIndex}
                        onClick={currentIndex === clickSliderGallery.length - 1 ? handleViewMoreImages : null}
                    /> :
                    <LazyImage styleName={`styles.revampMainImage styles.carCardImage`} alt={carAltTag} src={url} key={imgIndex}/>
                }
                {!isListingPage && (carCardFomoKey && isDesktopWishlistAdoptionVariant && showFomoStrip) && <div styleName={`styles.fomoSticker`}>
                    <p styleName={` styles.fomoText`}>
                        <span>
                            {fomoIcon && <img src={fomoIcon} alt={carCardFomoText} />}
                        </span>{carCardFomoText}
                    </p>
                </div>
                }
            </div>
        );
    };
    const renderImageSlider = () => {
        if (!hasTransparentCarImage && isListingPage && listingActive && isHydrated) {
            return (
                <React.Fragment>

                    <Slider
                        settings={settings}
                        ref={sliderRef}
                        afterChange={handleAfterChange}
                        beforeChange={handleBeforeChange}>
                        {(clickSliderGallery || []).map((content, imgIndex) => {
                            return renderListingCardImage(content, imgIndex);
                        })}
                    </Slider>
                    <CarouselPills cardImageData={cardImageData} activeIndex={currentIndex} isRevampVariant={true} />
                </React.Fragment>
            );
        }
        return renderListingCardImage(imageUrl);

    };
    const renderCarBadges = () => {
        if (currentIndex !== 0 || (cardImageData.currentIndex !== null)) {
            return null;
        }
        const isDealerBadgeHidden = carLabel === INVENTORY_CAR_CARD_LABELS.DEALER && !getAbExpirementVariant(stagingDealerBadge, EXPERIMENT_TYPE.VARIANT_A);
        if (isDealerBadgeHidden) {
            return null;
        }
        return <ClpInventoryCarCardBadges label={carLabel} value={getLabelText()} />;
    };

    const onWishlistNoteClick = (e) => {
        preventPropagation(e);
        setShowWishlistNote(!showWishlistNote);
    };

    const handleCarTourNudgeClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        fetchCarDetailsConnect(carId, {showS20GalleryVariant: false}, true).then(() => {
            setCarContent(item);
            setShowVideoGalleryModal(true);
            setVideoGalleryModalOpenConnect(true);
        });
        trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.VIDEO_TAG_SELECTED, {
            ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.VIDEO_TAG_SELECTED,
            eventLabel: carId
        });
    };
    const handleListingTypeClick = (e) => {
        if (!isClassifiedEnabled) {
            return;
        }
        preventPropagation(e);

        const tagName = isLuxuryCar ? FILTER_KEYS.CARS24_LUXE : isInternalListing ? FILTER_KEYS.CARS24 : FILTER_KEYS.CLASSIFIEDS;

        setShowSellerTypeInfo((prevState) => ({
            view: !prevState.view,
            key: tagName
        }));

        trackDesktopCustomEventsAU(GA_EVENTS.SELLER_TYPE_TAG_CLICKED.eventAction, {
            ...GA_EVENTS.SELLER_TYPE_TAG_CLICKED,
            eventLabel: tagName,
            app_id: carId
        });

        return;
    };

    const getLocationStripText = () => {
        // if (isInterstateLocation) {
        //     return `${suburb}${currentCarLocation ? `, ${currentCarLocation}` : ""}`;
        // }
        // if (distance && isClassifiedEnabled) {
        //     return `${suburb} (${distance} kms away)`;
        // }
        // return `${suburb}, ${currentCarLocation || ""}`;
        return locationLabel;
    };

    const isLuxuryStyleEnabled = isDesktopLuxuryCarsVariant && isLuxuryCar;
    const revampCarCardStyles = getSellerTypeStyle(PLATFORMS.DESKTOP, STYLE_COMPONENTS.INVENTORY_CAR_CARD, STYLE_KEYS.REVAMP_CAR_CARD, isLuxuryStyleEnabled, isInternalListing);
    const revampLocationContainerStyle = getSellerTypeStyle(PLATFORMS.DESKTOP, STYLE_COMPONENTS.INVENTORY_CAR_CARD, STYLE_KEYS.REVAMP_LOCATION_CONTAINER, isLuxuryStyleEnabled, isInternalListing);
    const sellerTypeImageRaw = CLASSIFIED_BRANDING_CONSTANTS[isLuxuryCar ? "luxury" : isInternalListing ? "internal" : "dealer"].logo;
    const sellerTypeImage = (sellerTypeImageRaw && typeof sellerTypeImageRaw === "object") ? sellerTypeImageRaw.default : sellerTypeImageRaw;
    const sellerTypeText = CLASSIFIED_BRANDING_CONSTANTS[isLuxuryCar ? "luxury" : isInternalListing ? "internal" : "dealer"].label;

    return (
        <TrackableCarCardItem event={eventData()} eventGA4={eventDataGA4()}>
            <div>
                {preload &&
                    <Helmet>
                        <link rel="preload" href={hasTransparentCarImage ? imageUrl : clickSliderGallery[0] || imageUrl} as={"image"} type="image/jpg" fetchPriority="high" />
                    </Helmet>
                }
                <div>
                    <span>
                        <meta content="AUD" />
                        <meta content={price && parseInt(price)} />
                    </span>
                </div>
                <React.Fragment>
                    <a className="invCarCard" styleName={revampCarCardStyles} href={absoluteURL} onClick={cardClickWrapper} target={carCardActionTarget}>
                        <div className={"align-self-center"} styleName={`styles.revampCarImage ${
                            hasTransparentCarImage ? "styles.carImageWrapper" : ""
                        } ${hasTransparentCarImage && isLuxuryCar ? "styles.luxuryCarImageWrapper" : ""
                        }`}>
                            {comingSoon ?
                                <div styleName="styles.comingSoonSection">
                                    <img styleName={"styles.comingSoonImage"} alt={carAltTag} src={comingSoonImageSrc} />
                                    <div styleName={"styles.comingSoonWrap"}>
                                        <span styleName={"styles.whatText"}>
                                            <button onClick={comingSoonInfo}>
                                                <img src={InfoIcon} /> <small styleName={"styles.showText"}>What does this mean?</small>
                                            </button>
                                        </span>
                                    </div>
                                    {renderCarBadges()}
                                </div>
                                :
                                <div styleName={"styles.revampImageWrapper"} onClick = {handleViewMoreImages}
                                    // onMouseEnter={() => handleShowCarousel(true)} onMouseLeave={() => handleShowCarousel(false)}
                                >
                                    {(isListingPage && !booked && listingActive && beforeChangeIndex.next === clickSliderGallery.length - 1) && <div styleName={"styles.overlay"} >
                                        <a>View more images <img src={ArrowIcon} /></a>
                                    </div>}
                                    {sold && <div styleName={"styles.soldOverlay"} />}
                                    {isListingPage && !sold && isHydrated &&
                                    <React.Fragment>
                                        {<CustomReactSlickNavigation
                                            handleClickCallback={handleSliderDirection}
                                            totalSlides={clickSliderGallery?.length || 0}
                                            currentIndex={currentIndex}
                                            cardHoverRef={cardHoverRef}
                                        />}
                                    </React.Fragment>}
                                    {renderImageSlider()}
                                    {renderCarBadges()}
                                    {showWishlist && <div styleName={ selectedWishlistCarId === carId ? "styles.revampWishlistIcon styles.selectedWishlistedCar" : "styles.revampWishlistIcon"}>
                                        <HeartIcon
                                            height={"24px"}
                                            width={"24px"}
                                            stroke="white"
                                            fill={isWishlistedCar(carId) ? "#F68921" : "#0000004D"}
                                            handleClick={onClickWishlist}
                                        />
                                    </div>
                                    }
                                </div>

                            }
                            {showRemoveIcon &&
                                <div styleName={"styles.closeIcon"} onClick={onClickWishlist}>
                                    <CloseButton
                                        type="white"
                                        source="wishlist"
                                    />
                                </div>}
                        </div>
                        <div styleName={`styles.revampOuter`}>
                            <div styleName={"styles.carNameWrap"}>
                                <div styleName={"styles.carPriceWrapperRevamp"}>
                                    <h2 styleName={"styles.revampCarNameHeading"}>
                                        {carFullName}
                                    </h2>
                                </div>
                                <div styleName={"styles.modelNameRevampWrapper"}>
                                    <p styleName={"styles.revampModelName"}>
                                        {variant}
                                    </p>
                                </div>
                            </div>
                            <div styleName={"styles.revampCarTypeDeliveryWrap"}>
                                <ul styleName={"styles.revampCarType"}>
                                    {kilometerLabel && <li>{kilometerLabel}</li>}
                                    {transmissionType && <li>{transmissionType}</li>}
                                    {fuelType && <li>{fuelType}</li>}
                                    {(
                                    item?.carTourPresent && showWebCarTour && (
                                            <div onClick={handleCarTourNudgeClick} styleName={"styles.playbtnWrap"}>
                                                <p styleName={"styles.carTour"}>
                                                    <img src={VIDEO_TOUR_ICON} />
                                                </p>
                                            </div>
                                        )
                                    )}
                                </ul>
                            </div>
                            <div>
                                <strong styleName={"styles.revampCarPriceValue styles.tooltipHolderLeft"}>
                                    {makePriceLabelRound(emiPerWeek)}<span>/week</span>
                                    <Tooltip
                                        showOnHover={true}
                                        customStyleHeading={true}
                                        // heading={toolTipTitle}
                                        body={toolTipBody}
                                        defaultTootlipStyle={defaultTootlipStyle}
                                        trackEvents={handleRepaymentInfoClick}
                                    >
                                        <img src={InfoOutline} alt="Weekly Payment" />
                                    </Tooltip>
                                </strong>
                                {defaultDownPayment === NUMBER.ZERO &&  <h6 styleName={"styles.zeroDeposit"}>$0 deposit</h6>}
                            </div>
                            <div styleName={"styles.priceWrap"}>
                                { ((tradeIn && tradeInToggleSelected) || showPriceWithTradeInApplied) ?
                                    <div styleName="styles.revampEcgContainer">
                                        <p styleName="styles.tradeInValue">
                                            <strong styleName="styles.revampTradeInEstimate">
                                                { makePriceLabelRound(estimatedPrice) }
                                            </strong>
                                            <span styleName="styles.revampSaleStrikeCtn">{priceLabel}</span>
                                        </p>
                                        {(tradeIn && tradeInToggleSelected || showPriceWithTradeInApplied) && (
                                            <div styleName={"styles.revampTradeInOuter"}>
                                                <p styleName={"styles.revampTradeIn"}>{isInternalListing ? "Trade-in price" : "Trade-in ineligible"}</p>
                                            </div>
                                        )}
                                    </div>
                                    :
                                    <div styleName={"styles.carPrice"}>
                                        <div styleName={"styles.text-align"}>
                                            <div styleName={"styles.revampEcgContainer"}>
                                                <strong styleName="styles.revampTradeInEstimate">
                                                    { (tradeIn && tradeInToggleSelected) ? makePriceLabelRound(estimatedPrice) : priceLabel }
                                                </strong>
                                                {(defaultSale || isPriceDropCar) && !(tradeIn && tradeInToggleSelected) && (
                                                    <span styleName="styles.revampSaleStrikeCtn">{makePriceLabelRound(initialListingPrice)}</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div styleName={revampLocationContainerStyle}>
                                <div styleName={"styles.distanceWrapper"}>
                                    {getLocationStripText() &&
                                        <React.Fragment>
                                            <img src={locationImg} />
                                            <p styleName={"styles.revampLocation"} onClick={(e) => {handleLocationClick(e);}}>
                                                <span>
                                                    {getLocationStripText()}
                                                </span>
                                            </p>
                                        </React.Fragment>
                                    }

                                </div>
                                <p styleName={"styles.revampLocation styles.sellerType"} onClick={(e) => {handleListingTypeClick(e);}}>
                                    {isHydrated && sellerTypeImage && <img src={sellerTypeImage} />}
                                    {sellerTypeText}
                                </p>
                            </div>
                            {(ampPageSource === PAGE_SOURCE.WISHLIST && wishlistNote) && <div styleName={`${!showWishlistNote ? "styles.stickyNoteWrapDefault" : "styles.stickyNoteWrap"}`} onClick={(e) => onWishlistNoteClick(e)}>
                                <img src={stickyNote} />
                                <p styleName={"styles.stickyNote"}>{wishlistNote}</p>
                            </div>}
                        </div>

                    </a>

                </React.Fragment>
                {showEcgPrice &&
                    <EGCPriceView
                        {...item}
                        onClose={handleEcgView}
                        config={config}
                        type={egcRenderType}
                        bodyType={item.body || item.bodyType}
                        cta={getCta()}
                    />
                }
                {showKBBModal &&
                <KbbPriceScreen
                    onClose={handleOpenMarketModal}
                    egc={egc}
                    vehicleRetailPrice={vehicleRetailPrice}
                    kbbValueProvidedOn={kbbValueProvidedOn}
                />}
                {showVideoGalleryModal && <VideoGallerySliderModal
                    videoUrl={carContent?.carTourData?.videoPlayerUrl}
                    showModal={true}
                    onClose={() => setShowVideoGalleryModal(false)}
                    chapters={carContent?.carTourData?.chapters}
                    source={PAGE_SOURCE.CLP}
                    isDesktopCtaOptimizationVariant={isDesktopCtaOptimizationVariant}
                />}
                {
                    dealerLocationModal && <DealerLocationModal
                        isOpen={dealerLocationModal}
                        handleClose={() => setShowDealerLocationModal(false)}
                        onLoginClick={onLoginClick}
                        isLoggedIn={isLoggedIn}
                        distance={distance}
                        dealerInfo={dealerInfoObject}
                        cmsConfig={cmsConfig}
                        leadAppointment={leadAppointment}
                    />
                }
                {
                    showLoggedInDealerRedirectModal && <LoggedInDealerRedirectModal
                        isOpen={showLoggedInDealerRedirectModal}
                        handleOnClose={() => setShowLoggedInDealerRedirectModal(false)}
                        dealerName={dealerInfoObject?.name || ""}
                        onViewDealer={handleViewDealerFromModal}
                        source="LOCATION"
                    />
                }
                {
                    showSellerTypeInfo.view && <SellerTypeInfo globalCmsConfig={globalCmsConfig}  activeTab={showSellerTypeInfo.key} onClose={() => setShowSellerTypeInfo({view: false, key: FILTER_KEYS.CARS24})} />
                }
            </div>

        </TrackableCarCardItem>
    );
};

InventoryCarCard.propTypes = {
    booked: PropTypes.bool,
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    appointmentId: PropTypes.string,
    make: PropTypes.string,
    model: PropTypes.string,
    bodyType: PropTypes.string,
    price: PropTypes.number,
    egc: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    variant: PropTypes.string,
    state: PropTypes.string,
    fuelType: PropTypes.string,
    config: PropTypes.object,
    onClickCallback: PropTypes.func,
    transmissionType: PropTypes.string,
    history: PropTypes.object,
    emiDetails: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    setOnLoginSuccessCallback: PropTypes.func,
    secureToken: PropTypes.string,
    isWishlistedCar: PropTypes.func,
    onClickAddToWishList: PropTypes.func,
    gtmFrom: PropTypes.string,
    showWishlist: PropTypes.bool,
    showRemoveIcon: PropTypes.bool,
    defaultTootlipStyle: PropTypes.string,
    allFilters: PropTypes.object,
    appliedFilters: PropTypes.array,
    item: PropTypes.object,
    index: PropTypes.number,
    selectedSort: PropTypes.object,
    impressionSource: PropTypes.string,
    comingSoon: PropTypes.bool,
    egcRenderType: PropTypes.bool,
    listingActive: PropTypes.bool,
    saveCheckoutSourcePathnameConnect: PropTypes.func,
    personalised: PropTypes.bool,
    saleConfig: PropTypes.object,
    expressDelivery: PropTypes.object,
    cardType: PropTypes.string,
    selectedCity: PropTypes.object,
    handleEcgViewCallback: PropTypes.func,
    tradeInToggleSelected: PropTypes.bool,
    userTradeInData: PropTypes.object,
    kbbAskingPrice: PropTypes.number,
    vehicleRetailPrice: PropTypes.number,
    email: PropTypes.string,
    listingType: PropTypes.string,
    isUserZeroDpVariant: PropTypes.bool,
    ampPageSource: PropTypes.string,
    carCardActionTarget: PropTypes.string,
    setLoginTypeConnect: PropTypes.func,
    preload: PropTypes.bool,
    showPriceWithTradeInApplied: PropTypes.bool,
    preventDefaultEvents: PropTypes.bool,
    isGuestLogin: PropTypes.bool,
    guestLoginProps: PropTypes.object,
    showLocationCallback: PropTypes.func, // Changed from object to func
    galleryOnTheFlyDesktop: PropTypes.object,
    testDriveConfig: PropTypes.object,
    webPriceDropDesktop: PropTypes.object,
    vehicleShortlistData: PropTypes.object,
    fomoText: PropTypes.object,
    desktopWishlistAdoption: PropTypes.object,
    showFomoStrip: PropTypes.bool,
    sectionSource: PropTypes.string,
    webCarTour: PropTypes.object,
    fetchCarDetailsConnect: PropTypes.func,
    setVideoGalleryModalOpenConnect: PropTypes.func,
    desktopCtaOptimization: PropTypes.object,
    distance: PropTypes.number,
    openLoginPopupConnect: PropTypes.func,
    createClassifiedLeadConnect: PropTypes.func,
    phoneNumberVerified: PropTypes.number,
    metaContent: PropTypes.any,
    cmsConfig: PropTypes.object,
    getDealerInfoConnect: PropTypes.func,
    fetchLeadAppointmentConnect: PropTypes.func,
    dealerInfo: PropTypes.any,
    classifiedConfig: PropTypes.bool,
    leadAppointment: PropTypes.object,
    globalCmsConfig: PropTypes.object,
    stagingDealerBadge: PropTypes.object,
    locationLabel: PropTypes.string,
    desktopLuxuryCars: PropTypes.object,
    isSourceSimilarCars: PropTypes.bool
};

export default withLogin(withWishlist(InventoryCarCard));
